import ExportadorModal from '../components/controls/ExportadorModal';
import ImportadorModal from '../components/controls/ImportadorModal';
import {
  HomeView,
  UnauthorizedView,
  VariablesView,
  VariablesGlobalesView,
  InmueblesView,
  InmuebleView,
  ComerciosView,
  ComercioView,
  VehiculosView,
  VehiculoView,
  CementeriosView,
  CementerioView,
  FondeaderosView,
  FondeaderoView,
  EspecialesView,
  EspecialView,
  EmisionDefinicionesView,
  EmisionDefinicionView,
  EmisionEjecucionesView,
  EmisionEjecucionView,
  TasasView,
  TasaView,
  SubTasasView,
  SubTasaView,
  CertificadosEscribanoView,
  PlantillasDocumentosView,
  TiposActosProcesalesView,
  OrganosJudicialesView,
  ClaseElementoView,
  TipoElementoView,
  ControladoresView,
  ContribuyentesView,
  CertificadosApremiosView,
  CertificadoApremioView,
  CertificadoApremioItemsView,
  TipoRelacionesCertificadoApremioPersonaView,
  ApremiosView,
  ApremioView,
  CuentaCorrienteView,
  DeudaView,
  ConvenioDefinicionesView,
  PlanPagoView,
  PlanPagoDefinicionesView,
  PlanPagoDefinicionView,
  PagoACuentaView,
  PagoContadoView,
  PageNotFoundView,
  EntidadesView,
  EntidadView,
  PagoContadoDefinicionView,
  PagoContadoDefinicionesView,
  ProcedimientosView,
  ProcedimientoView,
  CuentasPruebaView,
  RecibosEspecialesView,
  DerechosEspecialesView,
  ReciboEspecialView,
  PagoReciboEspecialView,
  TipoMultasView,
  TipoArrendamientoView,
  TablasDefinicionView,
  TablaDefinicionView,
  RubrosView,
  EscribanosView,
  CategoriasTasasView,
  CategoriasUbicacionesView,
  CategoriasVehiculosView,
  TipoControladoresView,
  TipoCondicionesEspecialesView,
  TipoRecargoDescuentosView,
  TipoMovimientosView,
  IncisoVehiculosView,
  ModelosDeclaracionesJuradasView,
  CalendarioView,
  BusquedaVepsView,
  ControlProcesosView,
  EstadoPlanesPagoView,
} from '../views';

import { TIPS } from "../consts/tips";

export const PrivateRoutes = [
  {
    index: 0,
    code: "home",
    path: "/",
    component: ContribuyentesView,
    title: "Home",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.HOME_VIEW,
  },
  {
    index: 5,
    code: "unauthorized",
    path: "/unauthorized",
    component: UnauthorizedView,
    title: "Unauthorized",
    showHeader: false,
    nivelMenu: 0,
    children: [],
  },

  // Tributos
  {
    index: 100,
    path: "",
    component: null,
    title: "Tributos",
    showHeader: true,
    nivelMenu: 1,
    children: [110,120,130,140,150,160,170]
  },
  {
    index: 110,
    code: "inmueble_view",
    path: "/inmuebles",
    component: InmueblesView,
    title: "Inmuebles",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.INMUEBLES_VIEW,
  },
  {
    index: 111,
    code: "inmueble_view",
    path: ["/inmueble/:mode", "/inmueble/:mode/:id"],
    component: InmuebleView,
    title: "Inmueble",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.INMUEBLE_FORM,
  },
  {
    index: 120,
    code: "comercio_view",
    path: "/comercios",
    component: ComerciosView,
    title: "Comercios",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.COMERCIOS_VIEW,
  },
  {
    index: 121,
    code: "comercio_view",
    path: ["/comercio/:mode", "/comercio/:mode/:id"],
    component: ComercioView,
    title: "Comercio",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.COMERCIO_FORM,
  },
  {
    index: 130,
    code: "vehiculo_view",
    path: "/vehiculos",
    component: VehiculosView,
    title: "Vehículos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.VEHICULOS_VIEW,
  },
  {
    index: 131,
    code: "vehiculo_view",
    path: ["/vehiculo/:mode", "/vehiculo/:mode/:id"],
    component: VehiculoView,
    title: "Vehículo",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.VEHICULO_FORM,
  },
  {
    index: 140,
    code: "cementerio_view",
    path: "/cementerios",
    component: CementeriosView,
    title: "Cementerios",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CEMENTERIOS_VIEW,
  },
  {
    index: 141,
    code: "cementerio_view",
    path: ["/cementerio/:mode", "/cementerio/:mode/:id"],
    component: CementerioView,
    title: "Cementerio",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CEMENTERIO_FORM,
  },
  {
    index: 150,
    code: "fondeadero_view",
    path: "/fondeaderos",
    component: FondeaderosView,
    title: "Fondeaderos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.FONDEADEROS_VIEW,
  },
  {
    index: 151,
    code: "fondeadero_view",
    path: ["/fondeadero/:mode", "/fondeadero/:mode/:id"],
    component: FondeaderoView,
    title: "Fondeadero",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.FONDEADERO_FORM,
  },
  {
    index: 160,
    code: "cuenta-especial_view",
    path: "/cuentas-especiales",
    component: EspecialesView,
    title: "Cuentas especiales",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CUENTAS_ESPECIALES_VIEW,
  },
  {
    index: 161,
    code: "cuenta-especial_view",
    path: ["/cuenta-especial/:mode", "/cuenta-especial/:mode/:id"],
    component: EspecialView,
    title: "Cuenta especial",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CUENTA_ESPECIAL_FORM,
  },
  {
    index: 170,
    code: "cuenta_view",
    path: "/contribuyentes",
    component: ContribuyentesView,
    title: "Contribuyentes",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CONTRIBUYENTES_VIEW,
  },
  {
    index: 171,
    code: "cuenta-corriente_view",
    path: "/cuenta-corriente/:filter/:mode/:id",
    component: CuentaCorrienteView,
    title: "Cuenta corriente",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CUENTA_CORRIENTE_VIEW,
  },
  {
    index: 172,
    code: "cuenta-pago_view",
    path: "/deuda/:mode/:id",
    component: DeudaView,
    title: "Deuda",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEUDA_FORM,
  },
  {
    index: 173,
    code: "cuenta-pago_view",
    path: "/plan-pago/:processKey",
    component: PlanPagoView,
    title: "Planes de pago",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.PLAN_PAGO_VIEW,
  },
  {
    index: 174,
    code: "cuenta-pago_view",
    path: "/pago-contado/:processKey",
    component: PagoContadoView,
    title: "Pago contado",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.PAGO_CONTADO_FORM,
  },
  {
    index: 175,
    code: "cuenta-pago_view",
    path: "/pago-acuenta/:processKey",
    component: PagoACuentaView,
    title: "Pago a cuenta",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.PAGO_ACUENTA_FORM,
  },

  // VEPs
  {
    index: 200,
    path: "",
    component: null,
    title: "VEPs",
    showHeader: true,
    nivelMenu: 1,
    children: [205,210,220,230]
  },
  {
    index: 205,
    code: "cuenta-pago_view",
    path: "/busqueda/veps",
    component: BusquedaVepsView,
    title: "Búsqueda de VEPs",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.BUSQUEDA_VEPS_VIEW,
  },
  {
    index: 210,
    code: "recibo-especial_view",
    path: "/derechos-especiales",
    component: DerechosEspecialesView,
    title: "Definición de derechos especiales",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DERECHOS_ESPECIALES_VIEW,
  },
  {
    index: 211,
    code: "recibo-especial_view",
    path: ["/derecho-especial/:mode", "/derecho-especial/:mode/:id"],
    component: ReciboEspecialView,
    title: "Definición de derecho especial",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    properties: {
      reciboEspecial: false
    },
    tipName: TIPS.NAME.ROUTES.DERECHO_ESPECIAL_FORM,
  },
  {
    index: 220,
    code: "recibo-especial_view",
    path: "/recibos-especiales",
    component: RecibosEspecialesView,
    title: "Definición de VEPs especiales",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RECIBOS_ESPECIALES_VIEW,
  },
  {
    index: 221,
    code: "recibo-especial_view",
    path: ["/recibo-especial/:mode", "/recibo-especial/:mode/:id"],
    component: ReciboEspecialView,
    title: "Definición de VEP especial",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    properties: {
      reciboEspecial: true
    },
    tipName: TIPS.NAME.ROUTES.RECIBO_ESPECIAL_FORM,
  },
  {
    index: 230,
    code: "cuenta-pago_edit",
    path: ["/pago-recibo-especial"],
    component: PagoReciboEspecialView,
    title: "Emisión de VEP especial",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    properties: {
      reciboEspecial: true
    },
    tipName: TIPS.NAME.ROUTES.PAGO_RECIBO_ESPECIAL_VIEW,
  },
  {
    index: 231,
    code: "cuenta-pago_edit",
    path: ["/pago-derecho-especial/:idCuenta"],
    component: PagoReciboEspecialView,
    title: "Emisión de derecho especial",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    properties: {
      reciboEspecial: false
    },
    tipName: TIPS.NAME.ROUTES.PAGO_DERECHO_ESPECIAL_FORM,
  },

  // Emisión
  {
    index: 300,
    path: "",
    component: null,
    title: "Emisión",
    showHeader: true,
    nivelMenu: 1,
    children: [310,320,330,340]
  },
  {
    index: 310,
    code: "procedimiento_view",
    path: "/procedimientos",
    component: ProcedimientosView,
    title: "Procedimientos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.PROCEDIMIENTOS_VIEW,
  },
  {
    index: 311,
    code: "procedimiento_view",
    path: ["/procedimiento/:mode", "/procedimiento/:mode/:id"],
    component: ProcedimientoView,
    title: "Procedimientos",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.PROCEDIMIENTO_FORM,
  },
  {
    index: 320,
    code: "emision-definicion_view",
    path: "/emision-definiciones",
    component: EmisionDefinicionesView,
    title: "Definiciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.EMISION_DEFINICIONES_VIEW,
  },
  {
    index: 321,
    code: "emision-definicion_view",
    path: ["/emision-definicion/:mode", "/emision-definicion/:mode/:id"],
    component: EmisionDefinicionView,
    title: "Definiciones",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.EMISION_DEFINICION_FORM,
  },
  {
    index: 330,
    code: "emision_view",
    path: "/emision-ejecuciones",
    component: EmisionEjecucionesView,
    title: "Ejecuciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.EMISION_EJECUCIONES_VIEW,
  },
  {
    index: 331,
    code: "emision_view",
    path: ["/emision-ejecucion/:mode", "/emision-ejecucion/:mode/:id"],
    component: EmisionEjecucionView,
    title: "Ejecuciones",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.EMISION_EJECUCION_FORM,
  },
  {
    index: 340,
    code: "cuenta-prueba_view",
    path: "/cuentas-prueba",
    component: CuentasPruebaView,
    title: "Cuentas de prueba",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CUENTAS_PRUEBA_VIEW,
  },

  // Financiacion
  {
    index: 400,
    path: "",
    component: null,
    title: "Financiación",
    showHeader: true,
    nivelMenu: 1,
    children: [410,420,430,440]
  },
  {
    index: 410,
    code: "plan-pago-definicion_view",
    path: "/convenio-definiciones",
    component: ConvenioDefinicionesView,
    title: "Convenios",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CONVENIO_DEFINICIONES_VIEW,
  },
  {
    index: 420,
    code: "plan-pago-definicion_view",
    path: "/planes-pago-definicion",
    component: PlanPagoDefinicionesView,
    title: "Planes de pago",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.PLAN_PAGO_DEFINICIONES_VIEW,
  },
  {
    index: 421,
    code: "plan-pago-definicion_view",
    path: ["/plan-pago-definicion/:mode", "/plan-pago-definicion/:mode/:id"],
    component: PlanPagoDefinicionView,
    title: "Definición de plan de pago",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.PLAN_PAGO_DEFINICION_FORM,
  },
  {
    index: 430,
    code: "pago-contado-definicion_view",
    path: "/pagos-contados-definicion",
    component: PagoContadoDefinicionesView,
    title: "Pagos contado",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.PAGOS_CONTADOS_DEFINICION_VIEW,
  },
  {
    index: 431,
    code: "pago-contado-definicion_view",
    path: ["/pago-contado-definicion/:mode", "/pago-contado-definicion/:mode/:id"],
    component: PagoContadoDefinicionView,
    title: "Definición de pago contado",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.PAGO_CONTADO_DEFINICION_FORM,
  },
  {
    index: 440,
    code: "cuenta-pago_view",
    path: "/estado-planes-pago",
    component: EstadoPlanesPagoView,
    title: "Estado de Planes de Pago",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.ESTADO_PLANES_PAGO_VIEW,
  },

  // Escribanos
  {
    index: 500,
    path: "",
    component: null,
    title: "Escribanos",
    showHeader: true,
    nivelMenu: 1,
    children: [505,510]
  },
  {
    index: 505,
    code: "apremio_view",
    path: "/escribanos",
    component: EscribanosView,
    title: "Escribanos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.ESCRIBANOS_VIEW,
  },
  {
    index: 510,
    code: "certificado-escribano_view",
    path: "/certificados-escribano",
    component: CertificadosEscribanoView,
    title: "Certificados",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CERTIFICADOS_ESCRIBANO_VIEW,
  },

  // Legales
  {
    index: 600,
    path: "",
    component: null,
    title: "Legales",
    showHeader: true,
    nivelMenu: 1,
    children: [610,620,630,640,650,660,670]
  },
  {
    index: 610,
    code: "apremio_view",
    path: "/entidades/organos-judiciales",
    component: OrganosJudicialesView,
    title: "Órganos judiciales",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.ORGANOS_JUDICIALES_VIEW,
  },
  {
    index: 620,
    code: "apremio_view",
    path: "/plantillas-documentos",
    component: PlantillasDocumentosView,
    title: "Plantillas documentos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.PLANTILLAS_DOCUMENTOS_VIEW,
  },
  {
    index: 630,
    code: "apremio_view",
    path: "/entidades/tipos-actos-procesales",
    component: TiposActosProcesalesView,
    title: "Tipos actos procesales",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPOS_ACTOS_PROCESALES_VIEW,
  },
  {
    index: 640,
    code: "certificado-apremio_view",
    path: "/entidades/tipo-relacion-certificado-apremio-persona",
    component: TipoRelacionesCertificadoApremioPersonaView,
    title: "Tipo relaciones certificado persona",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPO_RELACION_CERT_APREMIO_VIEW,
  },
  {
    index: 650,
    code: "certificado-apremio_view",
    path: "/certificados-apremio",
    component: CertificadosApremiosView,
    title: "Certificados",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CERTIFICADOS_APREMIOS_VIEW,
  },
  {
    index: 651,
    code: "certificado-apremio_view",
    path: ["/certificado-apremio/:mode", "/certificado-apremio/:mode/:id"],
    component: CertificadoApremioView,
    title: "Certificado",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CERTIFICADO_APREMIO_FORM,
  },
  {
    index: 660,
    code: "certificado-apremio_edit",
    path: "/certificado-apremio-nuevo",
    component: CertificadoApremioItemsView,
    title: "Nuevo certificado",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CERTIFICADO_APREMIO_NUEVO_FORM,
  },
  {
    index: 670,
    code: "apremio_view",
    path: "/apremios",
    component: ApremiosView,
    title: "Apremios",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.APREMIOS_VIEW,
  },
  {
    index: 671,
    code: "apremio_view",
    path: ["/apremio/:mode", "/apremio/:mode/:id"],
    component: ApremioView,
    title: "Apremio",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.APREMIO_FORM,
  },

  // Entidades
  {
    index: 700,
    path: "",
    component: null,
    title: "Entidades",
    showHeader: true,
    nivelMenu: 1,
    children: [709,710,720,725,730,731,733,734,740,750,753,754,755,756,760,770],
  },
  {
    index: 709,
    code: "listas_ingresos_publicos_view",
    path: "/entidades/categorias-tasas",
    component: CategoriasTasasView,
    title: "Categorías de tasas",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CATEGORIAS_TASAS_VIEW,
  },
  {
    index: 710,
    code: "tasa_view",
    path: "/tasas",
    component: TasasView,
    title: "Tasas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.TASAS_VIEW,
  },
  {
    index: 711,
    code: "tasa_view",
    path: ["/tasa/:mode", "/tasa/:mode/:id"],
    component: TasaView,
    title: "Tasa",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TASA_FORM,
  },
  {
    index: 712,
    code: "tasa_view",
    path: ["/tasa/nh/:mode", "/tasa/nh/:mode/:id"],
    component: TasaView,
    title: "Tasa",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TASA_FORM_NH,
  },
  {
    index: 720,
    code: "tasa_view",
    path: "/sub-tasas",
    component: SubTasasView,
    title: "Sub tasas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.SUBTASAS_VIEW,
  },
  {
    index: 721,
    code: "tasa_view",
    path: ["/sub-tasa/:mode", "/sub-tasa/:mode/:id"],
    component: SubTasaView,
    title: "Sub tasa",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.SUBTASA_FORM,
  },
  {
    index: 722,
    code: "tasa_view",
    path: ["/sub-tasa/nh/:mode", "/sub-tasa/nh/:mode/:id"],
    component: SubTasaView,
    title: "Sub tasa",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.SUBTASA_FORM_NH,
  },
  {
    index: 725,
    code: "tasa_view",
    path: "/entidades/tipo-movimientos",
    component: TipoMovimientosView,
    title: "Tipo de movimientos",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPO_MOVIMIENTOS_VIEW,
  },
  {
    index: 730,
    code: "controlador_view",
    path: "/entidades/controladores",
    component: ControladoresView,
    title: "Controladores",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CONTROLADORES_VIEW,
  },
  {
    index: 731,
    code: "controlador_view",
    path: "/entidades/tipo-controladores",
    component: TipoControladoresView,
    title: "Tipo de controladores",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPO_CONTROLADORES_VIEW,
  },
  {
    index: 734,
    code: "listas_ingresos_publicos_view",
    path: "/entidades/tipo-condiciones-especiales",
    component: TipoCondicionesEspecialesView,
    title: "Tipo de condiciones especiales",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPO_CONDICIONES_ESPECIALES_VIEW,
  },
  {
    index: 733,
    code: "listas_ingresos_publicos_view",
    path: "/entidades/tipo-recargos-descuentos",
    component: TipoRecargoDescuentosView,
    title: "Tipo de recargos y descuentos",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPO_RECARGOS_DESCUENTOS_VIEW,
  },
  {
    index: 740,
    code: "tipo-multa_view",
    path: "/entidades/tipos-multas",
    component: TipoMultasView,
    title: "Tipos de multas",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPOS_MULTAS_VIEW,
  },
  {
    index: 750,
    code: "comercio_view",
    path: "/entidades/tipos-arrendamientos",
    component: TipoArrendamientoView,
    title: "Tipos de arrendamientos",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPOS_ARRENDAMIENTOS_VIEW,
  },
  {
    index: 753,
    code: "listas_ingresos_publicos_view",
    path: "/entidades/inciso-vehiculos",
    component: IncisoVehiculosView,
    title: "Inciso vehículos",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.INCISO_VEHICULOS_VIEW,
  },
  {
    index: 754,
    code: "listas_ingresos_publicos_view",
    path: "/entidades/categorias-vehiculos",
    component: CategoriasVehiculosView,
    title: "Categorías de vehículos",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CATEGORIAS_VEHICULOS_VIEW,
  },
  {
    index: 755,
    code: "comercio_view",
    path: "/rubros",
    component: RubrosView,
    title: "Rubros",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RUBROS_VIEW,
  },
  {
    index: 756,
    code: "listas_ingresos_publicos_view",
    path: "/entidades/categorias-ubicaciones",
    component: CategoriasUbicacionesView,
    title: "Categorías de ubicaciones",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.CATEGORIAS_UBICACIONES_VIEW,
  },
  {
    index: 760,
    code: "listas_ingresos_publicos_view",
    path: "/entidades",
    component: EntidadesView,
    title: "Listas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.ENTIDADES_LISTAS_VIEW,
  },
  {
    index: 761,
    code: "listas_ingresos_publicos_view",
    path: ["/entidad/:mode/:tipo"],
    component: EntidadView,
    title: "Lista",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.ENTIDAD_FORM,
  },
  {
    index: 770,
    code: "tabla-definicion_view",
    path: "/tablas-definicion",
    component: TablasDefinicionView,
    title: "Tablas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.TABLAS_DEFINICION_VIEW,
  },
  {
    index: 771,
    code: "tabla-definicion_view",
    path: ["/tabla-definicion/:mode", "/tabla-definicion/:mode/:id"],
    component: TablaDefinicionView,
    title: "Tabla",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.TABLA_DEFINICION_FORM,
  },

  // Configuración
  {
    index: 800,
    path: "",
    component: null,
    title: "Configuración",
    showHeader: true,
    nivelMenu: 1,
    children: [810,820,830,840,845,846,850,860,870]
  },
  {
    index: 810,
    code: "variable_view",
    path: "/variables",
    component: VariablesView,
    title: "Definición de variables",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.VARIABLES_VIEW,
  },
  {
    index: 820,
    code: "variable_view",
    path: "/variables-globales",
    component: VariablesGlobalesView,
    title: "Variables globales",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.VARIABLES_GLOBALES_VIEW,
  },
  {
    index: 830,
    code: "variable_view",
    path: "/clases-elementos",
    component: ClaseElementoView,
    title: "Clases de elementos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CLASES_ELEMENTOS_VIEW,
  },
  {
    index: 840,
    code: "variable_view",
    path: "/tipos-elementos",
    component: TipoElementoView,
    title: "Tipos de elementos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.TIPOS_ELEMENTOS_VIEW,
  },
  {
    index: 845,
    code: "modelo-declaracion-jurada_view",
    path: "/modelos-declaraciones-juradas",
    component: ModelosDeclaracionesJuradasView,
    title: "Modelos de declaraciones juradas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.MODELOS_DECLARACIONES_JURADAS_VIEW,
  },
  {
    index: 846,
    code: "modelo-declaracion-jurada_view",
    path: "/calendario",
    component: CalendarioView,
    title: "Calendario",
    showHeader: true,
    nivelMenu: 2,
    children: [],
  },
  {
    index: 850,
    code: "importaciones",
    modal: ImportadorModal,
    title: "Importar",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.MODALS.IMPORTADOR_MODAL,
  },
  {
    index: 860,
    code: "exportaciones",
    modal: ExportadorModal,
    title: "Exportar",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.MODALS.EXPORTADOR_MODAL,
  },
  {
    index: 870,
    code: "proceso_view",
    path: "/configuracion/control-procesos",
    component: ControlProcesosView,
    title: "Control de procesos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CONTROL_PROCESOS_VIEW,
  },

  // not-found
  {
    index: 999,
    code: "not-found",
    path: "*",
    component: PageNotFoundView,
    title: "Página no encontrada",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.NOT_FOUND,
  },
];
